import {
  CompositeSourceStatus,
  CompositeSourceTargetKind,
} from '../config/compositeSourceEnums';

export function createLatestRequestGate() {
  let generation = 0;

  return {
    next() {
      generation += 1;
      return generation;
    },
    invalidate() {
      generation += 1;
    },
    isCurrent(candidate) {
      return candidate === generation;
    },
  };
}

export function nextWizardStep(currentStep, lastStep) {
  return Math.min(currentStep + 1, lastStep);
}

export function previousWizardStep(currentStep) {
  return Math.max(currentStep - 1, 1);
}

export function authoringActionLabel(status) {
  if (status === CompositeSourceStatus.Published) return 'Apply changes';
  if (status === CompositeSourceStatus.Broken) return 'Repair source';
  return 'Save draft';
}

export function sameAuthoringSnapshot(current, verified) {
  return !!current && !!verified
    && current.name === verified.name
    && current.json === verified.json;
}

function createPayload(target, name, definitionJson) {
  const payload = { name, definitionJson };
  if (target.kind === CompositeSourceTargetKind.FacilityGroup) {
    payload.facilityGroupId = target.id;
  } else {
    payload.facilityId = target.id;
  }
  return payload;
}

export async function persistWorkingCopy(command) {
  const payload = { name: command.name, definitionJson: command.definitionJson };

  if (!command.definitionId) {
    return command.service.create(
      createPayload(command.target, command.name, command.definitionJson),
      command.target.id,
    );
  }

  if (command.status === CompositeSourceStatus.Draft) {
    return command.service.update(
      command.definitionId,
      { ...payload, rowVersion: command.rowVersion },
      command.target.id,
      command.rowVersion,
    );
  }

  if (command.status === CompositeSourceStatus.Published
    || command.status === CompositeSourceStatus.Broken) {
    return command.service.apply(
      command.definitionId,
      payload,
      command.target.id,
      command.rowVersion,
    );
  }

  throw new Error(`Unsupported composite source status '${command.status}'.`);
}
